export default {"src":"/_next/static/media/easy-pickup.68f0a8bb.svg","height":119,"width":160,"blurWidth":0,"blurHeight":0};